// The system's file picker, hidden, opened from a button of our own.
//
// It cannot be styled -the browser does not allow it-, so it lives hidden and a
// button opens it. It is emptied after each pick: without that, choosing the
// same file twice in a row fires nothing and the button looks broken.
//
// Two places need one: the app frame, for the Brain panel and «Subir
// documento», and the full Brain screen, which has its own conversation and
// must not send the file to the panel's.

import { useCallback, useRef } from 'react'
import { ACCEPTED_FILE_TYPES } from '@/lib/document-type'

export function useFilePicker(
  onFile: (file: File) => void,
  label: string,
  accept: string = ACCEPTED_FILE_TYPES,
) {
  const input = useRef<HTMLInputElement>(null)
  const open = useCallback(() => input.current?.click(), [])

  const picker = (
    <input
      ref={input}
      type="file"
      className="hidden"
      tabIndex={-1}
      aria-label={label}
      accept={accept}
      onChange={(event) => {
        const file = event.target.files?.[0]
        event.target.value = ''
        if (file) onFile(file)
      }}
    />
  )

  return { open, picker }
}
